<script setup lang="ts">
    import { inject, ref } from 'vue';
    import List from '@shared/components/List/List.vue';
    import Preview from '@shared/components/Preview.vue';
    import StatisticsCommunicationItem from './StatisticsCommunicationItem.vue';
    import type { SurveyCommunicationIssue } from '../../SurveysTypes.d';
    import { injectorAccessInjectionKey } from '@cwd/lib/provider-keys';
    import { ContextAccess } from '@shared/Root/Context.access';
    import { combineUrlSegments } from '@shared/utils/combineUrlSegments';

    defineProps<{
        issues: SurveyCommunicationIssue[];
    }>();

    const injectorAccess = inject(injectorAccessInjectionKey)!;
    const contextAccess: ContextAccess = injectorAccess.injector.get(ContextAccess);

    const previewUrl = ref<string | null>(null);

    const showPreview = (issueId: string) => {
        previewUrl.value = combineUrlSegments(contextAccess.state.currentAccount!.PublicEventUrl.PublicHost, 'Issues', '' + issueId, '?preview=true');
    };

    const orderOptions = [
        { display: $Resources.IssuesSortByLastModifiedLabel, key: 'LastModified' },
        { display: $Resources.IssuesSortBySubjectLabel, key: 'Subject' },
        { display: $Resources.SentLabel, key: 'SentCount' },
        { display: $Resources.ReceivedLabel, key: 'ReceivedPercentage' },
        { display: $Resources.OpenedLabel, key: 'OpenPercentage' },
        { display: $Resources.ClickedLabel, key: 'ClickPercentage' },
    ];
</script>

<template>
    <List
        :items="issues"
        itemId="IssueId"
        :perPage="issues.length"
        :title="$Resources.SurveyCommunicationHeading"
        :description="$Resources.SurveyCommunicationBody"
        :filterKeys="['Subject', 'IssueName']"
        :orderOptions="orderOptions">
        <template #item="{ item }: { item: SurveyCommunicationIssue }">
            <StatisticsCommunicationItem :issue="item" @showPreview="showPreview(item.IssueId)" />
        </template>
    </List>

    <Preview :previewUrl="previewUrl" @close="previewUrl = null" />
</template>

